// Mock data for Renewed Environmental website

export const companyInfo = {
  name: "Renewed Environmental",
  tagline: "Your Trusted Waste Solutions Partner",
  phone: "(905) 595-6987",
  email: "info@renewedenv.com",
  logo: "https://customer-assets.emergentagent.com/job_cfeb1b66-6c5e-4501-81b6-be821e5cc4b3/artifacts/nhxgpe4g_Renewed%20Environmental%202.pdf"
};

export const binImages = {
  residential: "https://customer-assets.emergentagent.com/job_cfeb1b66-6c5e-4501-81b6-be821e5cc4b3/artifacts/y4iicaa2_ChatGPT%20Image%20Jan%206%2C%202026%2C%2001_58_33%20PM.png",
  commercial: "https://customer-assets.emergentagent.com/job_cfeb1b66-6c5e-4501-81b6-be821e5cc4b3/artifacts/cc8m5zwr_Gemini_Generated_Image_yu8pmayu8pmayu8p.png",
  construction: "https://customer-assets.emergentagent.com/job_cfeb1b66-6c5e-4501-81b6-be821e5cc4b3/artifacts/qqcpo0as_Gemini_Generated_Image_vz0hk5vz0hk5vz0h.png",
  industrial: "https://customer-assets.emergentagent.com/job_cfeb1b66-6c5e-4501-81b6-be821e5cc4b3/artifacts/vmvahoo3_Gemini_Generated_Image_65jh7665jh7665jh.png"
};

export const heroContent = {
  headline: "Complete Environmental",
  subheadline: "Solutions",
  description: "From bin rentals and waste management to soil remediation and hydrovac services — we deliver reliable, eco-friendly solutions for residential, commercial, and industrial projects across Ontario.",
  cta: "Get Started"
};

export const serviceAreas = [
  {
    id: 1,
    region: "Greater Toronto Area",
    phone: "(905) 595-6987",
    email: "info@renewedenv.com",
    hours: {
      weekday: "Monday - Friday: 7am to 5pm",
      saturday: "Saturday: 7am to noon",
      sunday: "Sunday & Stat Holidays: Closed"
    },
    showOrderButton: false
  },
  {
    id: 2,
    region: "Hamilton, Niagara & Tri-Cities",
    phone: "(905) 595-6987",
    email: "info@renewedenv.com",
    hours: {
      weekday: "Monday - Friday: 7am to 5pm",
      saturday: "Saturday: 7am to noon",
      sunday: "Sunday & Stat Holidays: Closed"
    },
    showOrderButton: false
  },
  {
    id: 3,
    region: "Barrie & Innisfil",
    phone: "(905) 595-6987",
    email: "info@renewedenv.com",
    hours: {
      weekday: "Monday - Friday: 6:30am to 4:30pm",
      saturday: "Saturday: Closed",
      sunday: "Sunday & Stat Holidays: Closed"
    },
    showOrderButton: false
  }
];

export const additionalLocations = [
  ["Ajax", "Aurora", "Barrie", "Bradford", "Brampton", "Brantford", "Burlington", "Guelph", "Cambridge", "Innisfil"],
  ["Hamilton", "Keswick", "Kitchener", "Markham", "Milton", "Mississauga", "Newmarket", "Oakville", "Orillia", "Orangeville"],
  ["Oshawa", "Pickering", "Scarborough", "St. Catharines", "Toronto", "Vaughan", "Waterloo", "Whitby", "Richmond Hill", "London"]
];

export const howItWorks = [
  {
    step: 1,
    title: "Choose Your Size",
    description: "Browse our range of bins and pick the perfect fit for your project",
    icon: "Package"
  },
  {
    step: 2,
    title: "Schedule Delivery",
    description: "Pick a date that works for you and we'll be there on time",
    icon: "Truck"
  },
  {
    step: 3,
    title: "Load & We Haul",
    description: "Fill it up at your own pace, then we handle the rest",
    icon: "CheckCircle"
  }
];

export const wasteTypes = [
  {
    id: "construction",
    category: "Large Projects",
    title: "Construction",
    startingPrice: 325,
    sizes: [
      { size: "14 Yard Bin", dimensions: "12.5'L x 8'W x 4'H" },
      { size: "20 Yard Bin", dimensions: "20'L x 8'W x 4'H" },
      { size: "30 Yard Bin", dimensions: "20'L x 8'W x 7'H" },
      { size: "40 Yard Bin", dimensions: "20'L x 8'W x 8'H" }
    ],
    note: "Generous Weight Included",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400"
  },
  {
    id: "household",
    category: "Residential",
    title: "Household",
    startingPrice: 300,
    sizes: [
      { size: "12 Yard Bin", dimensions: "10'L x 7'W x 4'H" },
      { size: "14 Yard Bin", dimensions: "10.5'L x 7'W x 4.5'H" },
      { size: "16 Yard Bin", dimensions: "12'L x 7'W x 5'H" },
      { size: "20 Yard Bin", dimensions: "13.5'L x 7'W x 5.5'H" },
      { size: "30 Yard Bin", dimensions: "14'L x 8'W x 8'H" }
    ],
    note: "Generous Weight Included",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400"
  },
  {
    id: "dirt",
    category: "Clean Fill",
    title: "Soil & Dirt",
    startingPrice: 240,
    sizes: [
      { size: "4 Yard Bin", dimensions: "12'L x 4'W x 2'H" },
      { size: "14 Yard Bin", dimensions: "12.5'L x 8'W x 4.5'H" }
    ],
    note: "Flat Rate Pricing",
    image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400"
  },
  {
    id: "concrete",
    category: "Clean Fill",
    title: "Concrete",
    startingPrice: 240,
    sizes: [
      { size: "4 Yard Bin", dimensions: "12'L x 4'W x 2'H" },
      { size: "6 Yard Bin", dimensions: "12'L x 5'W x 2'H" },
      { size: "14 Yard Bin", dimensions: "12.5'L x 8'W x 4.5'H" }
    ],
    note: "Flat Rate Pricing",
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=400"
  },
  {
    id: "brick",
    category: "Clean Fill",
    title: "Brick & Block",
    startingPrice: 240,
    sizes: [
      { size: "4 Yard Bin", dimensions: "12'L x 4'W x 2'H" },
      { size: "6 Yard Bin", dimensions: "12'L x 5'W x 2'H" },
      { size: "14 Yard Bin", dimensions: "12.5'L x 8'W x 4.5'H" }
    ],
    note: "Flat Rate Pricing",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400"
  },
  {
    id: "asphalt",
    category: "Clean Fill",
    title: "Asphalt",
    startingPrice: 240,
    sizes: [
      { size: "4 Yard Bin", dimensions: "12'L x 4'W x 2'H" },
      { size: "6 Yard Bin", dimensions: "12'L x 5'W x 2'H" },
      { size: "14 Yard Bin", dimensions: "12.5'L x 8'W x 4.5'H" }
    ],
    note: "Flat Rate Pricing",
    image: "https://images.unsplash.com/photo-1578922746465-3a80a228f223?w=400"
  }
];

export const acceptableItems = [
  {
    title: "Construction Debris",
    description: "Drywall, shingles, metal, tiles, flooring, carpet, lumber, and renovation materials.",
    icon: "HardHat"
  },
  {
    title: "Clean Fill Materials",
    description: "Soil, sod, concrete, clay bricks, gravel, and stone.",
    icon: "Mountain"
  },
  {
    title: "Yard & Garden",
    description: "Trees, branches, shrubs, landscaping debris and leaves.",
    icon: "TreeDeciduous"
  },
  {
    title: "Clean Wood",
    description: "Untreated lumber, pallets, and scrap wood.",
    icon: "Logs"
  }
];

export const projectTypes = [
  {
    title: "Home Renovations",
    description: "Upgrading your space? Our bins handle everything from old cabinets and drywall to flooring and fixtures. Clear out the old to make room for your dream renovation."
  },
  {
    title: "Declutter & Cleanouts",
    description: "Tackling the garage, basement, or attic? We make junk removal simple. From old furniture to appliances, electronics, and seasonal items — we've got you covered."
  },
  {
    title: "Commercial & Construction",
    description: "Keep your job site clean and compliant. Whether it's a new build, demolition, or commercial cleanout, our range of bin sizes handles projects of any scale."
  }
];

export const faqs = [
  {
    question: "Why choose Renewed Environmental for bin rentals?",
    answer: "We pride ourselves on transparent pricing, reliable service, and flexible rental terms. Our team is committed to making waste disposal hassle-free, with same-day or next-day delivery available in most areas. Plus, we prioritize recycling to minimize environmental impact."
  },
  {
    question: "How much does it cost to rent a bin?",
    answer: "Pricing depends on bin size, rental duration, your location, and the type of material you're disposing. Contact us for a free, no-obligation quote tailored to your project needs."
  },
  {
    question: "What payment methods do you accept?",
    answer: "We accept all major credit cards. A deposit is required at booking, with the final balance determined after pickup based on actual weight and any additional services."
  },
  {
    question: "How do I know which bin size to order?",
    answer: "Not sure? Give us a call! Our team can help you estimate based on your project type. Generally, household cleanouts need 12-20 yard bins, while construction projects often require 20-40 yard bins."
  },
  {
    question: "Can I rent multiple bins at once?",
    answer: "Absolutely! We regularly service contractors and large projects requiring multiple bins. Contact us for volume pricing and coordinated delivery schedules."
  },
  {
    question: "How do I book delivery and pickup?",
    answer: "Simply call us or fill out the contact form. We'll confirm your delivery date and send you all the details. When you're ready for pickup, just give us a call or book online."
  },
  {
    question: "What if my bin is overfilled?",
    answer: "For safety and transport regulations, materials cannot extend above the bin walls. If overfilled, we may need to remove excess items before pickup or apply an additional charge."
  },
  {
    question: "What items are NOT accepted?",
    answer: "We cannot accept hazardous materials including: aerosols, batteries, chemicals, paint, flammables, propane tanks, tires, oils, solvents, or medical waste. Contact us if you're unsure about a specific item."
  },
  {
    question: "Do you recycle the waste?",
    answer: "Yes! We're committed to sustainability. Materials like metal, wood, concrete, and drywall are sorted and recycled whenever possible. We divert as much as we can from landfills."
  },
  {
    question: "What areas do you service?",
    answer: "We proudly serve the Greater Toronto Area, Hamilton-Niagara region, and Barrie-Innisfil area. Check our service area section or call to confirm availability in your location."
  }
];

export const navLinks = [
  { name: "Home", href: "/" },
  { name: "How It Works", href: "#services" },
  { name: "Pricing", href: "#bins" },
  { name: "Areas", href: "#areas" },
  { name: "FAQ", href: "#faq" },
  { name: "Contact", href: "#contact" }
];
